export const applyListingLanguage = (listing, locale) => {
  if (
    listing &&
    listing.attributes &&
    listing.attributes.publicData &&
    listing.attributes.publicData[locale]
  ) {
    const defaultLang = listing.attributes.publicData.defaultLanguage || 'en';

    if (locale === defaultLang) {
      return listing;
    }

    const langData = listing.attributes.publicData[locale];
    const updatedAttributes = { ...listing.attributes };
    const updatedPublicData = { ...updatedAttributes.publicData };

    const translateArray = (field, itemKeyPrefix) => {
      if (!Array.isArray(updatedPublicData[field])) {
        return updatedPublicData[field];
      }
      const arr = updatedPublicData[field];
      return arr.map((item, idx) => {
        const key = `${itemKeyPrefix}_${idx}`;
        return langData[key] !== undefined ? langData[key] : item;
      });
    };

    const translateFaqs = () => {
      if (!Array.isArray(updatedPublicData.faqs)) return updatedPublicData.faqs;
      return updatedPublicData.faqs.map((faq, idx) => {
        const qKey = `faqs_${idx}_question`;
        const aKey = `faqs_${idx}_answer`;
        return {
          question: langData[qKey] !== undefined ? langData[qKey] : faq.question,
          answer: langData[aKey] !== undefined ? langData[aKey] : faq.answer,
        };
      });
    };

    const translateInstructions = () => {
      const translated = langData.instructions;
      if (!translated) return updatedPublicData.instructions;
      if (
        typeof updatedPublicData.instructions === 'object' &&
        typeof translated === 'object'
      ) {
        return { ...updatedPublicData.instructions, ...translated };
      }
      return translated;
    };

    const translateOnlineReviewSummary = () => {
      const translated = langData.online_review_summary;
      if (!translated) return updatedPublicData.online_review_summary;
      if (
        typeof updatedPublicData.online_review_summary === 'object' &&
        typeof translated === 'object'
      ) {
        return { ...updatedPublicData.online_review_summary, ...translated };
      }
      return translated;
    };

    const translateAdditionalCharges = () => {
      if (!Array.isArray(updatedPublicData.additional_charges)) {
        return updatedPublicData.additional_charges;
      }
      return updatedPublicData.additional_charges.map((charge, idx) => {
        const descKey = `additional_charges_${idx}_description`;
        return {
          ...charge,
          description:
            langData[descKey] !== undefined ? langData[descKey] : charge.description,
        };
      });
    };

    const translateEnvironmentalImpact = () => {
      const originalImpact = updatedPublicData.environmental_impact || {};
      const translatedBenefits = Array.isArray(originalImpact.benefits)
        ? originalImpact.benefits.map((benefit, idx) => {
            const key = `environmental_impact_benefits_${idx}`;
            return langData[key] !== undefined ? langData[key] : benefit;
          })
        : [];

      const paragraphKey = 'environmental_impact_paragraph';
      const translatedParagraph =
        langData[paragraphKey] !== undefined
          ? langData[paragraphKey]
          : originalImpact.paragraph;

      return {
        ...originalImpact,
        benefits: translatedBenefits,
        paragraph: translatedParagraph,
      };
    };

    const simpleFields = [
      'title',
      'description',
      'feeDescription',
      'where_the_item_can_be_used',
    ];
    simpleFields.forEach(field => {
      if (langData[field] !== undefined) {
        updatedAttributes[field] = langData[field];
        if (updatedPublicData[field] !== undefined) {
          updatedPublicData[field] = langData[field];
        }
      }
    });

    updatedPublicData.alternative_search_titles = translateArray(
      'alternative_search_titles',
      'alternative_search_titles'
    );
    updatedPublicData.environmental_impact = translateArray(
      'environmental_impact',
      'environmental_impact'
    );
    updatedPublicData.suggested_usage_of_this_item = translateArray(
      'suggested_usage_of_this_item',
      'suggested_usage_of_this_item'
    );
    updatedPublicData.return_care_instructions = translateArray(
      'return_care_instructions',
      'return_care_instructions'
    );
    updatedPublicData.faqs = translateFaqs();
    updatedPublicData.instructions = translateInstructions();
    updatedPublicData.online_review_summary = translateOnlineReviewSummary();
    updatedPublicData.additional_charges = translateAdditionalCharges();
    updatedPublicData.environmental_impact = translateEnvironmentalImpact();

    if (langData.feeDescription !== undefined) {
      updatedPublicData.feeDescription = langData.feeDescription;
    }

    Object.keys(langData).forEach(key => {
      if (
        !simpleFields.includes(key) &&
        !key.match(
          /^(alternative_search_titles|environmental_impact|suggested_usage_of_this_item|return_care_instructions|faqs|additional_charges)_\d+/
        ) &&
        key !== 'instructions' &&
        key !== 'online_review_summary'
      ) {
        if (Object.prototype.hasOwnProperty.call(updatedPublicData, key)) {
          updatedPublicData[key] = langData[key];
        }
      }
    });

    updatedAttributes.publicData = updatedPublicData;
    return {
      ...listing,
      attributes: updatedAttributes,
    };
  }
  return listing;
};
